import { ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import SnackbarCloseButton from "splash_components/SnackbarCloseButton/SnackbarCloseButton";
import SplashContact from 'splash_components/SplashContact/SplashContact';
import { SnackbarProvider } from 'notistack';
import React from 'react';

export default function SplashContactRoot() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#004080",
      },
      secondary: {
        main: "#FFFFFF",
      },
    },
  });

  return (
    <SnackbarProvider
      maxSnack={3}
      autoHideDuration={4500}
      action={(snackbarKey) => (
        <SnackbarCloseButton snackbarKey={snackbarKey} />
      )}
    >
      <ThemeProvider theme={theme}>
        <SplashContact />
      </ThemeProvider>
    </SnackbarProvider>
  );
}
